"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsAndStableIsotopes = void 0;
const elementsAndIsotopes_js_1 = require("./elementsAndIsotopes.js");
exports.elementsAndStableIsotopes = structuredClone(elementsAndIsotopes_js_1.elementsAndIsotopes);
for (const element of exports.elementsAndStableIsotopes) {
    element.isotopes = element.isotopes.filter((i) => {
        return typeof i.abundance === 'number' && i.abundance > 0;
    });
}
//# sourceMappingURL=elementsAndStableIsotopes.js.map